// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('appRecurringJournal/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('appRecurringJournal/getData', async (params, { dispatch }) => {
  dispatch(setLoading({ getData: true }))
  const consolidatedResponse = await axios.get('/JV/RecurringVoucherList', { params })

  dispatch(setLoading({ getData: false }))
  return {
    params,
    data: {data: {list: []}},
    consolidated: consolidatedResponse.data,
  }
})

export const appRecurringJournalSlice = createSlice({
  name: 'appRecurringJournal',
  initialState: {
    journal: {},
    data: [],
    consolidated: [],
    totalRecords: 1,
    totalRecordsConsolidated: 1,
    typeData: [],
    totalTypeRecords: 1,
    params: {},
    typeParams: {},
    loadingState: { getData: false, getTypeData: false, getJournal: false }
    // allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data.data.list
        state.consolidated = action.payload.consolidated.data.list
        state.totalRecords = action.payload.data.totalRecords
        state.totalRecordsConsolidated = action.payload.consolidated.totalRecords
        state.params = action.payload.params
      })
      .addCase(setLoading.fulfilled, (state, action) => {
        state.loadingState = action.payload
      })
  }
})

export default appRecurringJournalSlice.reducer
